// extracted by mini-css-extract-plugin
export var bodyContainer = "b7_SI";